"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsEmailGood = exports.getIsGoodProvider = exports.getCanReview = void 0;

var _reselect = require("reselect");

var _ModuleCompatibilityTagTypes = _interopRequireDefault(require("marketplace-lib/constants/ModuleCompatibilityTagTypes"));

var _GoodSubTypes = _interopRequireDefault(require("../constants/GoodSubTypes"));

var _auth = require("./auth");

var getGoodDetails = function getGoodDetails(state) {
  return state.goodDetails;
};

var getTransactionId = function getTransactionId(state) {
  return getGoodDetails(state).get('transactionId');
};

var getHasReviewed = function getHasReviewed(state) {
  return getGoodDetails(state).get('hasReviewed');
};

var getCanReview = (0, _reselect.createSelector)([getTransactionId, getHasReviewed], function (transactionId, hasReviewed) {
  return !!transactionId && !hasReviewed;
});
exports.getCanReview = getCanReview;
var getIsGoodProvider = (0, _reselect.createSelector)([_auth.getPortal, getGoodDetails], function (portal, goodDetails) {
  return portal.portal_id === goodDetails.get('providerPortalId');
});
exports.getIsGoodProvider = getIsGoodProvider;
var getIsEmailGood = (0, _reselect.createSelector)([getGoodDetails], function (goodDetails) {
  var goodSubType = goodDetails.get('subType');

  if (goodSubType === _GoodSubTypes.default.EMAIL_TEMPLATES) {
    return true;
  }

  var customModuleCompatibilityTag = goodDetails.get('customModuleCompatibilityTag');

  if (goodSubType === _GoodSubTypes.default.CUSTOM_MODULE && customModuleCompatibilityTag.size === 1 && customModuleCompatibilityTag.includes(_ModuleCompatibilityTagTypes.default.COMPATIBLE_EMAIL)) {
    return true;
  }

  if (goodSubType === _GoodSubTypes.default.PACKS && goodDetails.get('children').every(function (child) {
    return child.get('subType') === _GoodSubTypes.default.EMAIL_TEMPLATES;
  })) {
    return true;
  }

  return false;
});
exports.getIsEmailGood = getIsEmailGood;